import { render, staticRenderFns } from "./sendFoucusStrategy.vue?vue&type=template&id=ec7f81a4&"
import script from "./sendFoucusStrategy.vue?vue&type=script&lang=js&"
export * from "./sendFoucusStrategy.vue?vue&type=script&lang=js&"
import style0 from "./sendFoucusStrategy.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports